import { defineStore } from 'pinia';
import { decode_html_entities } from '../../../library/function/html';

// Insights store.
export const useInsightsStore = defineStore('insights', {
  state: () => ({
    insights: null,
  }),
  getters: {
    /**
     * Get the daily revenue customer calendar chart.
     *
     * @param {Object} state The state.
     * @returns {Object} The daily revenue customer calendar chart.
     */
    daily_revenue_customer_calendar_chart: (state) => {
      if (!state.insights?.daily_revenue_customer) return null;
      const { labels } = window.DATAAGENT_ORDER_METABOX;
      const { premium } = window.DATAAGENT_PLUGIN;
      let { daily_revenue_customer } = state.insights;

      // If not premium, limit the data to the last 7 days
      if (!premium) {
        daily_revenue_customer = Object.fromEntries(Object.entries(daily_revenue_customer).slice(-7));
      }

      // Categorize daily revenue by year
      const revenueByYear = Object.entries(daily_revenue_customer).reduce((acc, [date, revenue]) => {
        const year = date.split('-')[0];
        if (!acc[year]) {
          acc[year] = {};
        }
        acc[year][date] = revenue;
        return acc;
      }, {});

      // Transform the data to the format required by the chart
      const currency_symbol = decode_html_entities(labels.currency_symbol);
      let data = Object.entries(revenueByYear)
        .sort((a, b) => b[0] - a[0]) // Sort years in descending order
        .map(([year, revenue]) => {
          return {
            title: labels.daily_revenue_customer + ' ' + year,
            data: Object.entries(revenue).map(([date, revenue]) => [date, revenue]),
            year: parseInt(year),
            threshold: Object.values(labels.threshold),
            tooltip: {
              position: 'top',
              formatter: function (p) {
                return `${p.data[0]}: ${currency_symbol}${p.data[1]}`;
              },
            },
          };
        });

      return data;
    },
  },
  actions: {
    /**
     * Set insights.
     *
     * @param {Object} data
     */
    setInsights(data) {
      this.insights = data;
    },
  },
});
